var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CustomerForm',{attrs:{"customer":_vm.customer,"buttonLoading":_vm.buttonLoading},on:{"saveCustomer":_vm.saveCustomer}})
}
var staticRenderFns = []

export { render, staticRenderFns }